import { Box, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material";
import type { CompanyType } from "@entrilia/shared/api/clientTypes";
import { allCompanyTypes } from "@entrilia/shared/api/clientTypes";
import CompanyTypeBadge from "@entrilia/shared/components/CompanyTypeBadge";

interface Props {
  value: CompanyType;
  disabled: boolean;
  onChange: (value: CompanyType) => void;
}

const companyTypeDescription = {
  ["Production"]: "Production company",
  ["Demo"]: "Company for demonstrations",
  ["Template"]: "Blueprint company for replicating setups",
  ["Training"]: "Company for user training",
  ["Sandbox"]: "Experimental environment for testing and development",
};

const CompanyTypeSelect = ({ value, onChange, disabled }: Props) => {
  return (
    <FormControl>
      <InputLabel>Company Type</InputLabel>
      <Select
        label="Company Type"
        value={value}
        onChange={(e) => onChange(e.target.value as CompanyType)}
        renderValue={(selected) => <Typography>{selected}</Typography>}
        disabled={disabled}
      >
        {allCompanyTypes.map((companyType) => (
          <MenuItem key={companyType} value={companyType}>
            <Box sx={{ display: "flex", flex: 1, justifyContent: "space-between", alignItems: "center" }}>
              <Stack>
                <Typography>{companyType}</Typography>
                <Typography variant="caption" color="textSecondary">
                  {companyTypeDescription[companyType]}
                </Typography>
              </Stack>
              {companyType === "Production" ? (
                <Typography color="textSecondary">No tag</Typography>
              ) : (
                <CompanyTypeBadge type={companyType} />
              )}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CompanyTypeSelect;
